import { arrayOf, shape, string, func, number } from 'prop-types';
import React, { Fragment } from 'react';
import dynamic from 'next/dynamic';

import ArrowComponent from './Arrow';
import Menu from './Menu';

const ScrollMenu = dynamic(() => import('react-horizontal-scrolling-menu'), {
  ssr: false,
  loading: () => null
});

const ArrowLeft = ArrowComponent({
  direction: 'prev',
  className: 'VideoPlaylist__arrow VideoPlaylist__arrow-prev'
});
const ArrowRight = ArrowComponent({
  direction: 'next',
  className: 'VideoPlaylist__arrow VideoPlaylist__arrow-next'
});

const VideoPlaylist = ({
  playlistItems,
  currentVideoTitle,
  selected,
  onPlayVideo
}) => {
  const playlistMenuItems = Menu({ list: playlistItems, selected });
  return (
    <Fragment>
      <p className="VideoPlaylist__player-title">{currentVideoTitle}</p>
      <ScrollMenu
        data={playlistMenuItems}
        translate={0.5}
        itemStyle={{ outline: 'none' }}
        menuClass="VideoPlaylist"
        innerWrapperClass="VideoPlaylist__wrapper-inner"
        arrowClass="VideoPlaylist__control"
        arrowLeft={ArrowLeft}
        arrowRight={ArrowRight}
        selected={selected}
        onSelect={key => onPlayVideo(key)}
      />
    </Fragment>
  );
};

VideoPlaylist.propTypes = {
  playlistItems: arrayOf(shape({})).isRequired,
  currentVideoTitle: string,
  selected: number,
  onPlayVideo: func.isRequired
};

VideoPlaylist.defaultProps = {
  currentVideoTitle: '',
  selected: 0
};

export default VideoPlaylist;
